<wlm-profile-dialogs-hierarchy-grid
  *ngIf="userCode"
  [userCode]="userCode"
  fullSize="true"
></wlm-profile-dialogs-hierarchy-grid>
